var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'fee-root-container',
    _vm.feeType == 'out' ? 'fee-out' : '',
    _vm.feeType == 'in' ? 'fee-in' : '',
  ],style:({ fontSize: _vm.primarySize + 'px' })},[_vm._v(" ￥"+_vm._s(_vm.amountFormat.integer)+". "),_c('span',{style:({ fontSize: _vm.secondarySize + 'px' })},[_vm._v(_vm._s(_vm.amountFormat.decimal))])])
}
var staticRenderFns = []

export { render, staticRenderFns }